import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "aos/dist/aos.css";
import axios from 'axios'


const Event = () => {

const [categorizedImages, setCategorizedImages] = useState({});

useEffect(() => {
  axios.get('https://goforen.com/go_foren/get_activity_data/')
    .then((res) => {
      const data = res.data;

      // Group images by category
      const grouped = data.reduce((acc, item) => {
        const category = item.category?.toLowerCase() || "uncategorized";
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
        return acc;
      }, {});

      setCategorizedImages(grouped);
    })
    .catch((err) => {
      console.error('Failed to fetch gallery data:', err)
    })
}, []);

  const [background, setBackground] = useState("");

  useEffect(() => {
    const backgroundUrl = "/assets/pic/media.png";
    setBackground(backgroundUrl);
  }, []);
  const [background1, setBackground1] = useState("");

  useEffect(() => {
    const backgroundUrl1 =
      "https://html.xpressbuddy.com/e.visa/assets/img/bg/b_bg.jpg";
    setBackground1(backgroundUrl1);
  }, []);

  
          const [background12, setBackground12] = useState("");
        
          useEffect(() => {
            const backgroundUrl12 = "assets/img/bg/blog_bg.png";
            setBackground12(backgroundUrl12);
          }, []);
  const getImageSrc = (image_id) => `https://lh3.googleusercontent.com/d/${image_id}`

  const renderImages = (category) => (
    <div className="xb-countryes row">
      {categorizedImages[category]?.map((item, index) => (
        <div key={index} className="xb-itemes--itemes col-lg-3 col-md-4 col-12">
          <a href={getImageSrc(item.image_id)} data-fancybox={`gallery-${category}`} className="xb-item--inner">
            <div className="image" style={{ backgroundImage: `url(${getImageSrc(item.image_id)})` }}>
              <div className="overlay">
                <em className="mdi mdi-magnify-plus"></em>
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  )

  return (
    <>
      <Navbar />
      {/* <!-- breadcrumb start --> */}
      <section
        className="breadcrumb pos-rel bg_img"
        style={{
          backgroundImage: `url(${background})`,
          minHeight: "400px",
          position: "relative",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // black overlay with 50% opacity
            zIndex: 1,
          }}
        ></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcrumb__content">
            <h2 className="breadcrumb__title" style={{ color: "#fff" }}>
              Event
            </h2>
            <ul className="breadcrumb__list clearfix">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item">Event</li>
            </ul>
          </div>
        </div>

        {/* <div className="breadcrumb__circle">
          <span
            className="big"
            data-parallax='{"y" : 100, "scale" : 0.1}'
          ></span>
          <span
            className="small"
            data-parallax='{"y" : 100, "scale" : 0.1}'
          ></span>
        </div>
        <div className="breadcrumb__shape">
          <div className="shape shape--1">
            <div className="shape-inner" data-parallax='{"x":-50,"y":80}'>
              <img src="assets/img/shape/br_shape1.png" alt="" />
            </div>
          </div>
          <div className="shape shape--2">
            <div className="shape-inner" data-parallax='{"x":50,"y":-90}'>
              <img src="assets/img/shape/br_shape2.png" alt="" />
            </div>
          </div>
        </div> */}
      </section>
      {/* <!-- country end --> */}
      <section className="country pt-120 pb-130">
        <div className="container">
          <div
            className="sec-title"
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "30px",
            }}
          >
            <h2 className="mb-20 wow skewIn">Our Event</h2>
          </div>

          <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="coaching" role="tabpanel">
                {renderImages("activities")}
              </div>
          </div>

        </div>
      </section>

        {/* working time  */}
  <div style={{background:'#edf3f5',padding:'30px 0px'}}>
  <div className="container">
        <div
          className="xb-newsletter1 pos-rel "
          style={{
            backgroundImage: `url(${background12})`,
            // minHeight: '400px',
            position: "relative",
            backgroundSize: "cover",
            backgroundPosition: "center",
            margin: "30px 0px",
          }}
        >
          <div className="row">
            <div className="col-12">
              <div>
                <div className="sec-title mb-40 text-center">
                  <h2 className="mb-20 wow skewIn">Our Working Time</h2>
                  <p style={{ textAlign: "center" }}>
                    We are available throughout the week to help you with your
                    visa and training needs.
                  </p>
                </div>

                <div className="row justify-content-center text-center">
                  <div
                    className="col-lg-3 mt-30 col-md-6"
                    style={{
                      boxShadow: " 0px 14px 19px rgb(221 229 236)",
                      padding: "20px",
                      margin: "5px",
                    }}
                  >
                    <div>
                      <h5 className="mb-2">Monday - Saturday :</h5>
                      <p style={{ textAlign: "center" }}>
                        10.00 a.m. to 6.30 p.m.
                      </p>
                    </div>
                  </div>
                  {/* <div
                    className="col-lg-3 mt-30 col-md-6"
                    style={{
                      boxShadow: "0px 14px 19px rgb(221 229 236)",
                      padding: "20px",
                      margin: "5px",
                    }}
                  >
                    <h5 className="mb-2">Sunday :</h5>
                    <p style={{ textAlign: "center" }}>
                      10.00 a.m. to 12.30 p.m.
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      {/* workingtime end  */}
      <Footer />
    </>
  );
};

export default Event;
